@if (bare) {
  <router-outlet></router-outlet>
} @else {
  <admin-shell (signOut)="onSignOut()" [accountHref]="accountHref" [open]="_selection.open">
    <admin-nav admin-nav [items]="navItems" [activePath]="activePath"></admin-nav>
    <a
      admin-identity
      class="app-identity"
      routerLink="/profile"
      data-testid="app-identity-link"
    >
      @if (profile; as p) {
        {{ p.first_name }} {{ p.last_name }}
      }
    </a>
    <router-outlet></router-outlet>
    <app-move-panel admin-companion></app-move-panel>
  </admin-shell>
}
